import { SxProps, Theme } from '@mui/material';

import { customsProColors, muiGlobalTheme } from '@/muiGlobalTheme';

export const drawerWidth = 250;
export const drawerWidthClose = 70;

const stylesCommonNav = {
  boxSizing: 'border-box',
  color: 'primary.contrastText',
  overflowX: 'hidden',
  transition: muiGlobalTheme.transitions.create(['width', 'margin'], {
    easing: muiGlobalTheme.transitions.easing.sharp,
    duration: muiGlobalTheme.transitions.duration.leavingScreen,
  }),
};
const stylesCommonNavTransition = {
  transition: muiGlobalTheme.transitions.create(['width', 'margin'], {
    easing: muiGlobalTheme.transitions.easing.sharp,
    duration: muiGlobalTheme.transitions.duration.leavingScreen,
  }),
};

export const stylesNavDrawer = ({ isOpen, isSherpass }: { isOpen: boolean; isSherpass: boolean }) => {
  let styles: SxProps<Theme>;

  const background = isSherpass
    ? `linear-gradient(to bottom, ${customsProColors.channelPortGreen}  0%, ${customsProColors.brightGreen} 120%)`
    : `linear-gradient(to bottom, #00364E 0%, #00628D 120%)`;

  if (isOpen) {
    styles = {
      width: drawerWidth,
      ...stylesCommonNavTransition,
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        ...stylesCommonNav,
        ...stylesCommonNavTransition,
        background,
      },
    };
  } else {
    styles = {
      width: drawerWidthClose,
      ...stylesCommonNavTransition,
      '& .MuiDrawer-paper': {
        width: drawerWidthClose,
        ...stylesCommonNav,
        ...stylesCommonNavTransition,
        background,
      },
    };
  }
  return {
    ...styles,
    border: 1,
    background,
    boxShadow: 0,
    zIndex: 'modal',
    position: 'fixed',
    bgColor: muiGlobalTheme.palette.background.default,
  };
};

export const stylesDrawerLinks = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  pb: 3,
};

export const stylesLogo = {
  height: 42,
};

export const stylesLogoWrapper = (isOpen: boolean) => {
  let styles: SxProps<Theme>;

  if (isOpen) {
    styles = {
      width: 166,
      marginLeft: '',
      margin: '64px 0 0 22px',
    };
  } else {
    styles = {
      width: 43,
      margin: '64px auto 0',
    };
  }

  return {
    ...styles,
    ...stylesCommonNavTransition,
    overflow: 'hidden',
  };
};

export const stylesNavigationList = {
  flex: 1,
  mt: 5,
};
export const stylesNavigationItem = {
  my: 3,
  lineHeight: 'initial',
  opacity: 0.7,
  height: 40,
  '&:hover': {
    color: `white !important`,
  },
  '&.active': {
    background: 'linear-gradient(90deg, rgba(255,255,255,1) 4px, rgba(255,255,255,0) 4px)',
    opacity: 1,
  },
  '&.Mui-disabled': {
    opacity: 1,
    '&, .MuiListItemText-secondary': {
      color: 'grey.500',
    },
    '.MuiSvgIcon-root': {
      color: 'grey.500',
    },
  },
};

export const stylesSecurityPolicyNavigationItem = (isActif: boolean) => ({
  opacity: isActif ? 1 : 0.7,
  background: isActif ? 'linear-gradient(90deg, rgba(255,255,255,1) 4px, rgba(255,255,255,0) 4px)' : 'transparent',
});

export const stylesNavigationItemText = (isOpen: boolean) => {
  let styles: SxProps<Theme>;

  if (isOpen) {
    styles = {
      opacity: 1,
      lineHeight: 'initial',
      transition: muiGlobalTheme.transitions.create('opacity', {
        easing: muiGlobalTheme.transitions.easing.sharp,
        duration: muiGlobalTheme.transitions.duration.enteringScreen,
        delay: muiGlobalTheme.transitions.duration.shortest,
      }),
    };
  } else {
    styles = {
      flex: 0,
      opacity: 0,
      height: 0,
    };
  }

  return {
    ...styles,
    m: 0,
    fontWeight: 700,
    '.MuiListItemText-primary': {
      textTransform: 'uppercase',
      fontSize: '.813rem',
    },
    '.MuiListItemText-secondary': {
      fontStyle: 'italic',
      fontSize: '.625rem',
      lineHeight: 1,
    },
  };
};

export const stylesNavigationIcon = {
  minWidth: 'initial',
  width: 35,
  svg: {
    m: '0 auto',
  },
};

export const stylesSubNavigationIcon = {
  minWidth: 'initial',
  mr: muiGlobalTheme.spacing(2),
  ml: muiGlobalTheme.spacing(4),
};

export const stylesNavigationIconSVG = {
  color: 'primary.contrastText',
};
export const stylesNavigationLogout = {
  mt: 'auto',
};
